import React from 'react';
import { Table, Button, Space, Tag, Image } from 'antd';
import { EditOutlined, DeleteOutlined, EyeOutlined, EyeInvisibleOutlined, FileTextOutlined } from '@ant-design/icons';
import { format } from 'date-fns';

const PressReleaseTable = ({ pressReleases, onEdit, onDelete, onToggleStatus }) => {
  if (!pressReleases || pressReleases.length === 0) {
    return null; // Handled by parent component
  }

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return '';
    if (imageUrl.startsWith('http')) return imageUrl;
    // Use relative path to work with proxy
    return imageUrl;
  };

  const columns = [
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Press Release</span>,
      key: 'pressRelease',
      render: (_, release) => {
        const title = release?.title || 'Untitled';
        
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Image
              src={getImageUrl(release.imageUrl)}
              alt={title}
              width={60}
              height={40}
              style={{ 
                objectFit: 'cover',
                borderRadius: '4px'
              }}
              fallback="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='40'%3E%3Crect width='100%25' height='100%25' fill='%23e6d5f0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23470172' font-size='12'%3EImg%3C/text%3E%3C/svg%3E"
            />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 600, color: '#470172' }}>
                {title}
              </div>
              <div style={{ fontFamily: 'Rubik, sans-serif', fontSize: '14px', fontWeight: 400, color: '#8b8b8b' }}>
                {release?.description?.substring(0, 80) || 'No description'}...
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Newspaper</span>,
      dataIndex: 'newspaper',
      key: 'newspaper',
      responsive: ['md'],
      render: (newspaper) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FileTextOutlined style={{ color: '#470172' }} />
          <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '14px', fontWeight: 400, color: '#470172' }}>
            {newspaper || '—'}
          </span>
        </div>
      ),
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Date</span>,
      dataIndex: 'date',
      key: 'date',
      responsive: ['lg'],
      render: (date) => (
        <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '14px', fontWeight: 400, color: '#470172' }}>
          {date ? format(new Date(date), 'MMM d, yyyy') : '—'}
        </span>
      ),
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Status</span>,
      key: 'status',
      responsive: ['md'],
      render: (_, release) => (
        <Tag 
          color={release.isActive ? 'success' : 'default'}
          style={{ fontFamily: 'Rubik, sans-serif', fontSize: '14px', fontWeight: 400 }}
        >
          {release.isActive ? 'Active' : 'Inactive'}
        </Tag>
      ),
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Actions</span>,
      key: 'actions',
      align: 'right',
      render: (_, release) => (
        <Space size="small">
          <Button
            type="text"
            icon={release.isActive ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            onClick={() => onToggleStatus(release._id)}
            style={{ 
              color: '#470172',
              fontFamily: 'Rubik, sans-serif',
              fontSize: '16px',
              fontWeight: 400
            }}
          />
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEdit(release)}
            style={{ 
              color: '#470172',
              fontFamily: 'Rubik, sans-serif',
              fontSize: '16px',
              fontWeight: 400
            }}
          />
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete(release._id)}
            style={{ 
              fontFamily: 'Rubik, sans-serif',
              fontSize: '16px',
              fontWeight: 400
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={pressReleases}
      rowKey="_id"
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        style: { fontFamily: 'Rubik, sans-serif' }
      }}
      style={{ fontFamily: 'Rubik, sans-serif' }}
    />
  );
};

export default PressReleaseTable;
